export const setCache = (key, str, type = 1) => {
    if (type == 1) {
        localStorage.setItem(key, str)
    } else {
        sessionStorage.setItem(key, str)
    }

}

export const getCache = (key, type = 1) => {
    if (type == 1) {
        return localStorage.getItem(key)
    } else {
        return sessionStorage.getItem(key)
    }

}

export const clearCache = (key, type = 1) => {
    if (type == 1) {
        localStorage.clear()
    } else {
        sessionStorage.clear()
    }
}



// WEBPACK FOOTER //
// ./src/utils/cache.js